import React from 'react';
import MarkChatReadIcon from '@mui/icons-material/MarkChatRead';
import DeleteIcon from '@mui/icons-material/Delete';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Stack from '@mui/material/Stack';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import ListItemText from '@mui/material/ListItemText';

function ModalNoti({ open, setOpen, id, title, from, img, desc, handleDelete, isCheck, handleView }) {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    color: '#000',
    borderRadius: '20px',
    boxShadow: 24,
    border: 'none',
    p: 4,
  };
  return (
    <Modal onClose={() => setOpen(false)} onOpen={() => setOpen(true)} open={open}>
      <Box sx={style}>
        <ListItemAvatar>
          <Avatar alt={from} src={img} />
        </ListItemAvatar>
        <ListItemText
          primary={title}
          secondary={
            <React.Fragment>
              <Typography
                sx={{ display: 'inline' }}
                component="span"
                variant="body2"
                color="text.primary"
                className="notification-text"
              >
                {from}
              </Typography>
              {' — '} {desc}
            </React.Fragment>
          }
        />
        <Typography id="modal-modal-description" sx={{ mt: 2 }}></Typography>
        <Stack spacing={2} direction="row" sx={{ justifyContent: 'center', padding: '30px' }}>
          <Button variant="text" sx={{ borderRadius: '100px', height: '70px', width: '70px', color: '#7199ff' }}>
            <MarkChatReadIcon sx={{ fontSize: '38px' }} onClick={() => handleView(id)} />
          </Button>
          <Button variant="text" color="error" sx={{ borderRadius: '100px', height: '70px', width: '70px' }}>
            <DeleteIcon sx={{ fontSize: '38px' }} onClick={() => handleDelete(id)} />
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
}

export default ModalNoti;
